import { createContext, useCallback, useContext, useEffect, useState } from "react";

export const BASKET_EVENT = "basketUpdated";

interface BasketContextType {
  basketCount: number;
}

const BasketContext = createContext<BasketContextType>({ basketCount: 0 });

export function BasketProvider({ children }: { children: React.ReactNode }) {
  const [basketCount, setBasketCount] = useState(0);

  const refresh = useCallback(() => {
    try {
      const stored = localStorage.getItem("basket");
      const basket = stored ? JSON.parse(stored) : null;
      setBasketCount(basket?.items?.length ?? 0);
    } catch {
      setBasketCount(0);
    }
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener(BASKET_EVENT, refresh);
    return () => window.removeEventListener(BASKET_EVENT, refresh);
  }, [refresh]);

  return (
    <BasketContext.Provider value={{ basketCount }}>
      {children}
    </BasketContext.Provider>
  );
}

export const useBasket = () => useContext(BasketContext);
